var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.supportOptionsCount > 0 ? _c('div', {
    staticClass: "fab-container"
  }, [_c('b-button', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top.html",
      value: _vm.popoverContent,
      expression: "popoverContent",
      modifiers: {
        "hover": true,
        "top": true,
        "html": true
      }
    }],
    staticClass: "fab-button",
    class: {
      'fab-button--expanded': _vm.isHovered
    },
    attrs: {
      "id": _vm.buttonId,
      "variant": "primary",
      "pill": "",
      "aria-label": _vm.$t('support.help'),
      "data-testid": "fab-button"
    },
    on: {
      "mouseenter": function ($event) {
        _vm.isHovered = true;
      },
      "mouseleave": function ($event) {
        _vm.isHovered = false;
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "fab-icon",
    attrs: {
      "icon": ['fas', 'question-circle']
    }
  }), _c('transition', {
    attrs: {
      "name": "fade-slide"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isHovered,
      expression: "isHovered"
    }],
    staticClass: "fab-text"
  }, [_vm._v(_vm._s(_vm.$t("support.support")))])])], 1), _c('b-popover', {
    attrs: {
      "target": _vm.buttonId,
      "triggers": "click",
      "placement": "top",
      "custom-class": "fab-popover"
    },
    on: {
      "show": _vm.onPopoverShow,
      "hide": _vm.onPopoverHide
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_c('div', {
          staticClass: "popover-header-content"
        }, [_c('div', {
          staticClass: "header-icon-container"
        }, [_c('span', [_vm._v(_vm._s(_vm.$t("support.hello-there")))]), _c('WavingHandIcon', {
          staticClass: "header-icon"
        })], 1), _c('span', {
          staticClass: "support-title"
        }, [_vm._v(_vm._s(_vm.$t("support.title")))]), _c('button', {
          staticClass: "close-button",
          attrs: {
            "aria-label": "Close",
            "data-testid": "close-popover"
          },
          on: {
            "click": _vm.closePopover
          }
        }, [_c('font-awesome-icon', {
          attrs: {
            "icon": ['fas', 'times']
          }
        })], 1)])];
      },
      proxy: true
    }], null, false, 2474292561)
  }, [_c('div', {
    staticClass: "support-options",
    class: {
      'single-column': _vm.supportOptionsCount === 1
    }
  }, _vm._l(_vm.supportOptions, function (option) {
    var _option$target;

    return _c('a', {
      key: option.key,
      staticClass: "support-option",
      attrs: {
        "href": _vm.getLink(option.link),
        "target": option.target || '_blank',
        "rel": ((_option$target = option.target) !== null && _option$target !== void 0 ? _option$target : '_self') ? null : 'noopener noreferrer',
        "data-testid": ((option.key) + "-support")
      },
      on: {
        "click": function ($event) {
          return _vm.trackSupportClick(option.key);
        }
      }
    }, [_c(option.icon, {
      tag: "component",
      staticClass: "option-icon"
    }), _c('span', {
      staticClass: "option-title"
    }, [_vm._v(_vm._s(_vm.$t(option.translation)))])], 1);
  }), 0)])], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }